import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogOut, Smartphone, MessageSquare } from "lucide-react";
import InstancesPage from "./InstancesPage";
import logo from "../assets/i2.png";

const Main = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user_id");
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-white">

      {/* Main Content */}
      <motion.div
        className=""
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <InstancesPage />
      </motion.div>
    </div>
  );
};

export default Main;
